export const RASPI_API = process.env.NODE_ENV === 'development'
    ? 'http://localhost:8080/'
    : 'http://localhost:8080/';


export const OLED_SOCKET_API  = process.env.NODE_ENV === 'development'
    ? 'http://192.168.2.9:5200'
    : 'http://192.168.2.9:5200';